import React, { FC } from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { ITrajectoryDifferentiation } from '../../../../config/api/models/Trajectory';
import { TextFieldAdapter, validations, SidebarTitle } from '../../../shared/components';
import { DifferentiationScreenAction } from './DifferentiationScreenAction';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import {
  DifferentiationsFormContent,
  DifferentiationsFormWrapper,
  FieldDisabler,
  FieldDisablerWrapper,
  StyledForm,
  StyledFormGroup,
  StyledLocalLoading,
} from './Atoms';
import { BottomBar } from 'src/modules/shared/components/BottomBar/BottomBar';

type Props = {
  handleSubmit: () => void;
  version?: ITrajectoryDifferentiation;
  openCallback: (screen: DifferentiationScreenAction, meta?: object) => void;
  submitting?: boolean;
};

const env = process.env.REACT_APP_ENVIRONMENT;

export const DifferentiationForm: FC<Props> = ({
  handleSubmit,
  version,
  openCallback,
  submitting = false,
}) => {
  const { t } = useTranslation();
  return (
    <DifferentiationsFormWrapper>
      <DifferentiationsFormContent>
        <SidebarTitle
          title={
            (version && t('differentiations.updateVersion')) ||
            t('differentiations.addVersionButton')
          }
          icon={SpriteIconsLight.EDIT}
        />
        <StyledForm onSubmit={handleSubmit}>
          <FieldDisablerWrapper>
            <StyledFormGroup id="title" label={t('differentiations.form.name')} required>
              <Field
                defaultValue={version ? version.title : ''}
                name="title"
                component={TextFieldAdapter}
                validate={validations(t).required}
              />
            </StyledFormGroup>
            {submitting && <FieldDisabler />}
          </FieldDisablerWrapper>
          {submitting && <StyledLocalLoading />}
        </StyledForm>
        {env === 'demo' && (
          <Alert
            severity="warning"
            color="warning"
            style={{ marginTop: '16px', marginBottom: '1rem', color: '#FFFFFF' }}
          >
            <Typography
              variant="body1"
              style={{ fontWeight: 600, marginBottom: '8px', color: '#ffffff' }}
            >
              Prober zeker de mogelijkheden.
            </Typography>
            <Typography
              variant="body2"
              style={{ fontWeight: 600, fontSize: '14px', color: '#ffffff' }}
            >
              Maar wat je in deze demo-omgeving maakt, kan je later niet meenemen naar het volledige
              platform.
            </Typography>
          </Alert>
        )}
      </DifferentiationsFormContent>
      <BottomBar
        icon={SpriteIconsLight.CIRCLE_PLUS}
        submitText={t('shared.save')}
        hasCancelButton
        submitCallback={handleSubmit}
        cancelCallback={() => openCallback(DifferentiationScreenAction.OVERVIEW)}
        cancelText={t('shared.forms.cancel')}
        disableSubmit={submitting}
        disableCancel={submitting}
      />
    </DifferentiationsFormWrapper>
  );
};
